import { loadPage } from '../../helpers';

export const goToSignup = () => {
  loadPage('/signup', true);
};

export const goToGift = () => {
  loadPage('/gift', true);
};
